import { css } from '@emotion/react';

import { typography } from '@coursera/cds-common';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('TableBodyCell', [
  'endAligned',
  'verticalMiddleAligned',
]);

const getTableBodyCellCss = css`
  ${typography.body1};
  border-bottom: 1px solid var(--cds-color-neutral-stroke-primary-weak);
  min-width: 120px;
  padding: var(--cds-spacing-300);
  text-align: inherit;
  vertical-align: top;

  &.${classes.endAligned} {
    text-align: end;
  }

  &.${classes.verticalMiddleAligned} {
    vertical-align: middle;
  }
`;

export default getTableBodyCellCss;
